<template>
    <div class="licence__show_table">
        <component-table
            :labels="tableLabels"
            :items="items"
            :component-table-item="LicenceShowTableItem"
            :component-table-collapse-item="LicenceShowTableCollapseTable"
            :component-table-collapse-item-active="activeCollapseIndex"
            @emit-collapse="handleCollapse"
            @emit-sort="handleSort"
        />
    </div>
</template>

<script>
import ComponentTable from '@/components/default/shared/ComponentTable'
import LicenceShowTableItem from '@/components/ebs/licences/show/LicenceShowTableItem'
import LicenceShowTableCollapseTable from '@/components/ebs/licences/show/LicenceShowTableItemCollapseTable'

export default {
  components: {
    ComponentTable
  },
  name: 'licence-show-table',
  data () {
    return {
      activeCollapseIndex: '',
      LicenceShowTableItem,
      LicenceShowTableCollapseTable
    }
  },
  props: {
    items: {
      type: Array
    }
  },
  computed: {
    tableLabels () {
      let itemsArr = []

      itemsArr.push({
        key: 'accessedBy',
        title: 'Accessed by',
        type: 'string',
        sortable: true,
        queryable: true
      })
      itemsArr.push({
        key: 'latestAccessDate',
        title: 'Latest access date',
        type: 'string',
        sortable: true,
        queryable: true
      })
      itemsArr.push({
        key: 'numberOfAttempts',
        title: 'Number of attempts',
        type: 'string',
        sortable: true,
        queryable: true
      })
      itemsArr.push({
        key: 'actions',
        title: '',
        type: 'string'
      })

      return itemsArr
    }
  },
  methods: {
    handleSort (data) {
      this.$emit('emit-sort', data)
    },
    handleCollapse (value) {
      this.activeCollapseIndex = this.activeCollapseIndex !== value ? value : ''
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/licences/licenceshowtable";
</style>
